import { useEffect, useState, useCallback } from "react";
import Image from "next/image";
import PopupForm from "../PopupForm/PopupForm";
import YoutubeVideoPopup from "../YoutubeVidioPopup/YoutubeVidioPopup";
import usePopupVisibility from "../PopupForm/usePopupVisibility";
import {
  initMixpanel,
  trackCTAClick,
  trackEventPreEnrolment,
} from "@/services/mixpanel";

interface CTAProps {
  ctaData?: any;
  reactIconsLeft?: any;
  reactIconsRight?: any;
  btnLabelMobile?: string;
  btnLabelDesktop?: string;
  buttonName?: string;
  position?: string;
  btnTextClr?: string;
  btnClr?: string;
  btnUrl?: string;
  pageSlug?: string;
  isProgramPage?: string;
  preEnrollmentEnable?: boolean;
  btnType?: "pop-up" | "redirection-link" | "youtube-video";
  btnIcon?: {
    icon?: { url: string };
    horizontal_position?: "left" | "right";
  };
  imageIconRight?: any;
  mixpanelEvent?: any;
  popupData?: any;
  saveEvenCmsData?: boolean;
  saveDataOnVinecrm?: boolean;
  formFieldsSection?: any;
  EventTitle?: string;
  programOfIntrestLP?: any;
  programOfInterestMultipleOptionList?: boolean;
}

const CustomiseCta: React.FC<CTAProps> = ({
  position = "",
  btnLabelDesktop = "Enrol now",
  btnLabelMobile = btnLabelDesktop || "Enrol now",
  btnTextClr = "",
  btnClr = "",
  btnUrl = "",
  btnType = "pop-up",
  btnIcon,
  reactIconsLeft,
  reactIconsRight,
  pageSlug = "",
  isProgramPage = "",
  ctaData,
  preEnrollmentEnable,
  imageIconRight,
  mixpanelEvent,
  popupData,
  programOfIntrestLP,
  programOfInterestMultipleOptionList,
}) => {
  const { isPopupVisible, hidePopup, showPopup } = usePopupVisibility();
  const [isYoutubePopup, setIsYoutubePopup] = useState(false);
  const [youtubeVideoLink, setYoutubeVideoLink] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const [timeOnPage, setTimeOnPage] = useState(0);
  const [clickCount, setClickCount] = useState(0);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 700);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    initMixpanel();
    const timer = setInterval(() => setTimeOnPage((prev) => prev + 1), 1000);
    return () => clearInterval(timer);
  }, []);
  const buttonLabel = isMobile
    ? ctaData?.button?.mobile_label ?? btnLabelMobile
    : ctaData?.button?.desktop_label ?? btnLabelDesktop;

  const handleCTAClick = useCallback(() => {
    setClickCount((prev) => prev + 1);
    if (mixpanelEvent) {
      trackEventPreEnrolment(mixpanelEvent, {
        page_url: window.location.href,
      });
    }
    if (!mixpanelEvent) {
      trackCTAClick(
        buttonLabel,
        position,
        timeOnPage,
        clickCount,
        window.location.pathname
      );
    }
  }, [position, timeOnPage, clickCount, buttonLabel, mixpanelEvent]);

  const buttonTextClr = ctaData?.button?.text_color ?? btnTextClr;
  const buttonClr = ctaData?.button?.button_color ?? btnClr;
  const buttonUrl = ctaData?.button?.url ?? btnUrl;
  const buttonType = ctaData?.type ?? btnType;
  const buttonIcon = ctaData?.icon_and_position ?? btnIcon;

  const handleCTA = () => {
    handleCTAClick();
    if (buttonType === "pop-up") {
      showPopup();
    } else if (buttonType === "redirection-link" && buttonUrl) {
      window.open(buttonUrl, "_blank");
    } else if (buttonType === "youtube-video" && buttonUrl) {
      setYoutubeVideoLink(buttonUrl);
      setIsYoutubePopup(true);
    }
  };

  const handleCloseVideo = () => {
    setIsYoutubePopup(false);
    setYoutubeVideoLink("");
  };

  return (
    <>
      <button
        onClick={handleCTA}
        style={{
          backgroundColor: buttonClr || "",
          color: buttonTextClr || "",
          border: "none",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
        }}
      >
        {buttonIcon?.icon?.url && buttonIcon.horizontal_position === "left" && (
          <Image
            src={buttonIcon.icon.url}
            alt="Icon"
            title="Icon"
            width={22}
            height={22}
          />
        )}
        {!buttonIcon?.icon?.url && <span>{reactIconsLeft}</span>}
        {!buttonIcon?.icon?.url && imageIconRight && (
          <Image
            src={imageIconRight}
            alt="Icon"
            title="Icon"
            width={20}
            height={20}
          />
        )}
        {buttonLabel}

        {buttonIcon?.icon?.url &&
          buttonIcon.horizontal_position === "right" && (
            <Image
              src={buttonIcon.icon.url}
              alt="Icon"
              title="Icon"
              width={22}
              height={22}
            />
          )}
        {!buttonIcon?.icon?.url && <span>{reactIconsRight}</span>}
      </button>

      {isPopupVisible && (
        <PopupForm
          isVisible={isPopupVisible}
          onClose={hidePopup}
          pageSlug={pageSlug}
          isProgramPage={isProgramPage}
          preEnrollmentEnable={preEnrollmentEnable}
          buttonLabel={buttonLabel}
          popupData={popupData}
          popUpData={popupData}
          programOfIntrestLP={programOfIntrestLP}
          programOfInterestMultipleOptionList={programOfInterestMultipleOptionList}
        />
      )}

      {isYoutubePopup && (
        <YoutubeVideoPopup
          isVisibleVideo={isYoutubePopup}
          onClose={handleCloseVideo}
          youtubeVideoLink={youtubeVideoLink}
        />
      )}
    </>
  );
};

export default CustomiseCta;
